import React, { memo, forwardRef } from "react";
const SvgAlphabetL = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M14.8 9.6c0-.28.04-.507.12-.68.093-.187.2-.327.32-.42.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .206.02.34.06.146.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v12.8c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.134.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7V9.6z"
      />
    </svg>
  );
});
SvgAlphabetL.displayName = "SvgAlphabetL";
const MemoForwardRef = memo(SvgAlphabetL);
export default MemoForwardRef;
